import { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { status } from 'constants/general';
import advertisersStrings from 'modules/advertisers/strings';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  AddAdvertiserWrapper,
  FormWrapper,
  FormTitle,
  FormGrid,
  FormLabel,
  FormTextInput,
  FormFieldWrapper,
  FormValidationError,
  FormBtnWrapper,
  FormBtn,
} from './AddAdvertiserComponent.style';

const AddAdvertiserComponent = ({
  formFieldsValues,
  formFieldsValidation,
  handleTextInputFieldChange,
  handleAddOrEditAdvertiserBtnClick,
}) => {
  const { addOrEditAdvertiser } = useSelector(state => ({
    addOrEditAdvertiser: state.advertisers.addOrEditAdvertiser,
  }));

  const themeContext = useContext(ThemeContext);
  const { colors } = themeContext;

  const { id: advertiserKey } = useParams();

  const formBtnText =
    (advertiserKey && advertisersStrings.addAdvertiser.formEditBtnText) ||
    advertisersStrings.addAdvertiser.formAddBtnText;

  return (
    <AddAdvertiserWrapper>
      <FormWrapper>
        <FormTitle>{advertisersStrings.addAdvertiser.formTitle}</FormTitle>
        <SectionDivider gap={16} withSeparator separatorGap={16} borderColor={colors.grey004} />
        <FormGrid>
          {/* Name Field */}
          <FormFieldWrapper>
            <FormLabel>{advertisersStrings.addAdvertiser.formNameFieldLabel}</FormLabel>
            <SectionDivider gap={8} />
            <FormTextInput
              type="text"
              value={formFieldsValues.name}
              onChange={event => handleTextInputFieldChange('name', event)}
            />
            {formFieldsValidation.name === false && (
              <>
                <SectionDivider gap={4} />
                <FormValidationError>
                  {advertisersStrings.addAdvertiser.formFieldErrorText(
                    advertisersStrings.addAdvertiser.formNameFieldLabel,
                  )}
                </FormValidationError>
              </>
            )}
          </FormFieldWrapper>

          {/* Phone Field */}
          <FormFieldWrapper>
            <FormLabel>{advertisersStrings.addAdvertiser.formPhoneFieldLabel}</FormLabel>
            <SectionDivider gap={8} />
            <FormTextInput
              type="number"
              value={formFieldsValues.phone}
              onChange={event => handleTextInputFieldChange('phone', event)}
            />
            {formFieldsValidation.phone === false && (
              <>
                <SectionDivider gap={4} />
                <FormValidationError>
                  {advertisersStrings.addAdvertiser.formFieldErrorText(
                    advertisersStrings.addAdvertiser.formPhoneFieldLabel,
                  )}
                </FormValidationError>
              </>
            )}
          </FormFieldWrapper>

          {/* Email Field */}
          <FormFieldWrapper span={2}>
            <FormLabel>{advertisersStrings.addAdvertiser.formEmailFieldLabel}</FormLabel>
            <SectionDivider gap={8} />
            <FormTextInput
              type="text"
              value={formFieldsValues.email}
              onChange={event => handleTextInputFieldChange('email', event)}
            />
            {formFieldsValidation.email === false && (
              <>
                <SectionDivider gap={4} />
                <FormValidationError>
                  {advertisersStrings.addAdvertiser.formFieldErrorText(
                    advertisersStrings.addAdvertiser.formEmailFieldLabel,
                  )}
                </FormValidationError>
              </>
            )}
          </FormFieldWrapper>
        </FormGrid>
        <SectionDivider gap={35} />
        <FormBtnWrapper>
          <FormBtn as="button" onClick={handleAddOrEditAdvertiserBtnClick}>
            {(addOrEditAdvertiser.status === status.FETCHING && (
              <Loader width={14} height={14} thickness={4} />
            )) ||
              formBtnText}
          </FormBtn>
        </FormBtnWrapper>
      </FormWrapper>
    </AddAdvertiserWrapper>
  );
};

AddAdvertiserComponent.propTypes = {
  formFieldsValues: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  formFieldsValidation: PropTypes.shape({
    name: PropTypes.bool,
    phone: PropTypes.bool,
    email: PropTypes.bool,
  }).isRequired,
  handleTextInputFieldChange: PropTypes.func.isRequired,
  handleAddOrEditAdvertiserBtnClick: PropTypes.func.isRequired,
};

export default AddAdvertiserComponent;
